import React from 'react';
import { TextField, Autocomplete, CircularProgress, Chip } from '@mui/material';
import { Person } from '@mui/icons-material';
import { GraphUser } from '../../../../../utils/MsGraphApiCall';
import { UserSearchOption } from '../common';

interface UserPoolAutocompleteProps {
  value: GraphUser[];
  users: GraphUser[];
  isLoading: boolean;
  searchQuery: string;
  onInputChange: (value: string) => void;
  onChange: (_event: React.SyntheticEvent, users: GraphUser[]) => void;
  error?: boolean;
  helperText?: string;
}

export const UserPoolAutocomplete: React.FC<UserPoolAutocompleteProps> = ({
  value,
  users,
  isLoading,
  searchQuery,
  onInputChange,
  onChange,
  error = false,
  helperText,
}) => (
  <Autocomplete
    multiple
    size="small"
    options={users}
    loading={isLoading}
    value={value}
    onChange={onChange}
    onInputChange={(_event, newInputValue) => onInputChange(newInputValue)}
    getOptionLabel={(option) => option.displayName || option.mail || ''}
    isOptionEqualToValue={(option, val) => option.id === val.id}
    noOptionsText={searchQuery.length < 2 ? 'Type to search users...' : 'No users found'}
    renderTags={(tagValue, getTagProps) =>
      tagValue.map((option, tagIndex) => (
        <Chip
          {...getTagProps({ index: tagIndex })}
          key={option.id}
          label={option.displayName || option.mail}
          size="small"
          icon={<Person />}
        />
      ))
    }
    renderInput={(params) => (
      <TextField
        {...params}
        label="User Pool"
        placeholder="Search and add users..."
        error={error}
        helperText={helperText || 'Add users to the round-robin rotation pool'}
        InputProps={{
          ...params.InputProps,
          endAdornment: (
            <>
              {isLoading ? <CircularProgress color="inherit" size={20} /> : null}
              {params.InputProps.endAdornment}
            </>
          ),
        }}
      />
    )}
    renderOption={(props, option) => (
      <UserSearchOption user={option} {...props} />
    )}
  />
);
